const productCatalog = [
  {
    id: "classico",
    title: "Classico Romano",
    subtitle: "La cava, levigata",
    code: "SIL / 01",
    collection: "Lastre",
    salesMode: "area",
    image:
      "https://www.poggibros.it/wp-content/uploads/2021/03/classico-D-cf_44A1098-1.jpg",
    description: "Avorio caldo, poro naturale e una venatura che attraversa il progetto con discrezione.",
    price: 86,
    unit: "€/m²",
    size: "120 × 60 cm",
    finish: "Levigato / stuccato",
    testId: "product-card-classico",
  },
  {
    id: "navona",
    title: "Navona Avorio",
    subtitle: "Luce diffusa",
    code: "SIL / 02",
    collection: "Lastre",
    salesMode: "area",
    image:
      "https://www.poggibros.it/wp-content/uploads/2021/03/navona-controfalda.jpg",
    description: "Un tono chiaro e continuo per superfici ampie, scale e rivestimenti senza tempo.",
    price: 98,
    unit: "€/m²",
    size: "240 × 120 cm",
    finish: "Spazzolato / opaco",
    testId: "product-card-navona",
  },
  {
    id: "noce",
    title: "Noce Imperiale",
    subtitle: "Venatura intensa",
    code: "SIL / 03",
    collection: "Lastre",
    salesMode: "area",
    image:
      "https://www.poggibros.it/wp-content/uploads/2021/03/noce-C-falda_O7B0239-1.jpg",
    description: "Caffè, miele e ombre profonde per camini, bagni e dettagli che chiedono carattere.",
    price: 118,
    unit: "€/m²",
    size: "120 × 60 cm",
    finish: "Levigato / poro aperto",
    testId: "product-card-noce",
  },
  {
    id: "titanium",
    title: "Titanium Silver",
    subtitle: "Minerale, grafite",
    code: "SIL / 04",
    collection: "Lastre",
    salesMode: "area",
    image:
      "https://www.poggibros.it/wp-content/uploads/2021/07/silver-d-falda_44A1117.jpg",
    description: "Una base nocciola con riflessi argento e movimento calcareo per architetture nette.",
    price: 132,
    unit: "€/m²",
    size: "240 × 120 cm",
    finish: "Fiammato / R11",
    testId: "product-card-titanium",
  },
  {
    id: "cannetato",
    title: "Cannettato 3D",
    subtitle: "Materia in rilievo",
    code: "SIL / 05",
    collection: "Lavorazioni",
    salesMode: "area",
    image:
      "https://www.poggibros.it/wp-content/uploads/2024/03/RET_7665-1-scaled.jpg.webp",
    description: "Pannelli scanalati in Travertino Romano per quinte, banconi e pareti che cambiano con la luce.",
    price: 185,
    unit: "€/m²",
    size: "60 × 120 cm",
    finish: "Poro aperto / scanalato",
    testId: "product-card-cannetato",
  },
  {
    id: "lavabo",
    title: "Vasca Monolito",
    subtitle: "Scolpita dal blocco",
    code: "SIL / 06",
    collection: "Elementi",
    salesMode: "quantity",
    image:
      "https://www.poggibros.it/wp-content/uploads/2022/03/BATHTUB_3.jpg.webp",
    description: "Un elemento bagno scolpito in Travertino Romano, con forme morbide e inserto in vetro.",
    price: 740,
    unit: "€/pezzo",
    size: "Su misura",
    finish: "Poro naturale / vetro",
    testId: "product-card-lavabo",
  },
];

export const commercialConfig = {
  availability: {
    value: "1.420 m²",
    label: "blocchi in pronta selezione",
  },
  checkout: {
    onlineEnabled: false,
    supportEmail: "info@sil-stoneinlove.com",
    unavailableMessage: "Al momento l'acquisto online non è ancora attivo. Scrivici la tua richiesta a:",
  },
  products: productCatalog,
  thicknessFactor: {
    "2 cm": 1,
    "3 cm": 1.22,
  },
};

export const products = commercialConfig.products;
export const thicknessFactor = commercialConfig.thicknessFactor;
export const rates = Object.fromEntries(
  products.filter((product) => product.collection === "Lastre").map((product) => [product.title, product.price]),
);
